import {TRANSLATION, Yup, QUESTION_TYPES} from '@/imports-files/pages/career/view-job';

const phoneRegex = /^\+?[\d\s]+$/;
export const APPLICATION_FILE_SIZE_LIMIT = 25000000;
export const CV_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'rtf', 'ppt']
export const OTHER_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'rtf', 'ppt', 'jpeg', 'jpg', 'png']


export function applyJobInitialValues(job){
  return { job_application: {
    candidate_linkedin_url            :   '',
    portfolio_url                     :   '',
  	first_name                        :   '',
    last_name                         :   '',
  	email                             :	  '',
  	contact_no                        :	  '',
    terms_accepted                    :   false,
    social_media_detail               :   '',
    without_cv                        :  false,
    resume_attributes                 :   {
                                            file_type   : '',
                                            file        : '',
                                            file_name   : ''
                                          },
    job_application_files_attributes  :  [],
    without_cv:  job.without_cv,
    screening_answers_attributes: job.screening_questions_attributes.map((question, question_index) =>{
      return {
        text: '',
        screening_question_id: question.id,
        options: [],
        question_type_name: question.question_type_name,
        mandatory: question.mandatory
      }
    })
  }}
}

export const VALIDATION_SCHEMA = Yup.object().shape({
  job_application: Yup.object().shape({
                                        without_cv            : Yup.boolean(),
                                        candidate_linkedin_url:   Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url'),
                                        portfolio_url:   Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url'),
                                        first_name            :   Yup.string().required(TRANSLATION('common:errors:required')),
                                        last_name             :   Yup.string().required(TRANSLATION('common:errors:required')),
                                        contact_no            :   Yup.string().matches(phoneRegex, TRANSLATION('page:admins:client:company:errors:contact_no'))
                                                                              .min(8, 'Contact No is too short (minimum is 8 characters)')
                                                                              .max(20, 'Contact No is too long (maximum is 20 characters)').required(TRANSLATION('common:errors:required')),
                                        email                 :   Yup.string().email(TRANSLATION('common:errors:invalid_email')).required(TRANSLATION('common:errors:required')),
                                        social_media_detail   :   Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url'),
                                        terms_accepted        :   Yup.boolean()
                                                                    .required("The terms and conditions must be accepted.")
                                                                    .oneOf([true], "The terms and conditions must be accepted."),
                                        resume_attributes     :   Yup.object().when('without_cv', {
                                                                                                    is        :  false,
                                                                                                    then      :  Yup.object().shape( { file_name: Yup.string().required(TRANSLATION('common:errors:required'))}),
                                                                                                  }),
                                        screening_answers_attributes: Yup.array().of(
                                                                        Yup.object({
                                                                          mandatory: Yup.boolean(),
                                                                          question_type_name: Yup.string(),
                                                                          text: Yup.string().when(["mandatory", "question_type_name"], {
                                                                            is: (mandatory, question_type_name) => mandatory && [QUESTION_TYPES.SINGLE_LINE, QUESTION_TYPES.MULTIPLE_LINE].includes(question_type_name),
                                                                            then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true)
                                                                          }),
                                                                          options: Yup.array().when(["mandatory", "question_type_name"], {
                                                                            is: (mandatory, question_type_name) => mandatory && [QUESTION_TYPES.SINGLE_CHOICE, QUESTION_TYPES.YES_NO, QUESTION_TYPES.MULTIPLE_CHOICE].includes(question_type_name),
                                                                            then: Yup.array().min(1, TRANSLATION('common:errors:required')),
                                                                            otherwise: Yup.array().notRequired()
                                                                          })
                                                                        })
                                                                      )
                                    })
})

export function submitAnswerInitialValues(job, candidate_detail){
  return { job_application: {
    id: candidate_detail.job_application_id,
    screening_answers_attributes: job.screening_questions_attributes.map((question, question_index) =>{
      return {
        text: '',
        screening_question_id: question.id,
        options: [],
        question_type_name: question.question_type_name,
        mandatory: question.mandatory
      }
    })
  }}
}
export function submitAnswerSchema() {
  return Yup.object().shape({
    job_application: Yup.object().shape({
      screening_answers_attributes: Yup.array().of(
        Yup.object({
          mandatory: Yup.boolean(),
          question_type_name: Yup.string(),
          text: Yup.string().when(["mandatory", "question_type_name"], {
            is: (mandatory, question_type_name) => mandatory && [QUESTION_TYPES.SINGLE_LINE, QUESTION_TYPES.MULTIPLE_LINE].includes(question_type_name),
            then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true)
          }),
          options: Yup.array().when(["mandatory", "question_type_name"], {
            is: (mandatory, question_type_name) => mandatory && [QUESTION_TYPES.SINGLE_CHOICE, QUESTION_TYPES.YES_NO, QUESTION_TYPES.MULTIPLE_CHOICE].includes(question_type_name),
            then: Yup.array().min(1, TRANSLATION('common:errors:required')),
            otherwise: Yup.array().notRequired()
          })
        })
      )
    })
  })
}